import React from 'react';
import { connect } from 'react-redux';

import { QuestionForm, } from '../../../Shared/index'
import questionActions from '../../actions/questions'

const NewSentenceCombiningQuestion = ({ dispatch, concepts, }) => {
  const submitNewQuestion = (questionObj, optimalResponseObj) => {
    dispatch(questionActions.submitNewQuestion(questionObj, optimalResponseObj))
  };

  return <QuestionForm concepts={concepts} isNew={true} question={{}} submit={submitNewQuestion} />
}

function select(state) {
  return {
    concepts: state.concepts,
  };
}

export default connect(select)(NewSentenceCombiningQuestion);
